const metrics = [
    {
        name: "wellbeing-balance",
        value: 8.52,
        oldValue: 5.09,
    },
    {
        name: "wellbeing-patterns",
        value: 7.23,
        oldValue: 3.78,
    },
];

const overall = {
    value: 7.87,
    oldValue: 6.69,
};

const timeseries = [
    {
        subcategory: "wellbeing_balance",
        name: "bou",
        datetime: "2024-04-11 00:00:00",
        value: 1,
    },
    {
        subcategory: "wellbeing_balance",
        name: "bou",
        datetime: "2024-04-12 00:00:00",
        value: 1,
    },
    {
        subcategory: "wellbeing_balance",
        name: "bou",
        datetime: "2024-04-13 00:00:00",
        value: 1,
    },
    {
        subcategory: "wellbeing_balance",
        name: "bou",
        datetime: "2024-04-14 00:00:00",
        value: 1,
    },
    {
        subcategory: "wellbeing_balance",
        name: "bou",
        datetime: "2024-04-15 00:00:00",
        value: 1,
    },
    {
        subcategory: "wellbeing_balance",
        name: "bou",
        datetime: "2024-04-16 00:00:00",
        value: 1,
    },
    {
        subcategory: "wellbeing_balance",
        name: "bou",
        datetime: "2024-04-17 00:00:00",
        value: 1,
    },
    {
        subcategory: "wellbeing_balance",
        name: "eho",
        datetime: "2024-04-11 00:00:00",
        value: 1,
    },
    {
        subcategory: "wellbeing_balance",
        name: "eho",
        datetime: "2024-04-12 00:00:00",
        value: 1,
    },
    {
        subcategory: "wellbeing_balance",
        name: "eho",
        datetime: "2024-04-13 00:00:00",
        value: 1,
    },
    {
        subcategory: "wellbeing_balance",
        name: "eho",
        datetime: "2024-04-14 00:00:00",
        value: 1,
    },
    {
        subcategory: "wellbeing_balance",
        name: "eho",
        datetime: "2024-04-15 00:00:00",
        value: 1,
    },
    {
        subcategory: "wellbeing_balance",
        name: "eho",
        datetime: "2024-04-16 00:00:00",
        value: 1,
    },
    {
        subcategory: "wellbeing_balance",
        name: "eho",
        datetime: "2024-04-17 00:00:00",
        value: 1,
    },
    {
        subcategory: "wellbeing_balance",
        name: "oohc",
        datetime: "2024-04-11 00:00:00",
        value: 1,
    },
    {
        subcategory: "wellbeing_balance",
        name: "oohc",
        datetime: "2024-04-12 00:00:00",
        value: 7.8,
    },
    {
        subcategory: "wellbeing_balance",
        name: "oohc",
        datetime: "2024-04-13 00:00:00",
        value: 8.533,
    },
    {
        subcategory: "wellbeing_balance",
        name: "oohc",
        datetime: "2024-04-14 00:00:00",
        value: 8.9,
    },
    {
        subcategory: "wellbeing_balance",
        name: "oohc",
        datetime: "2024-04-15 00:00:00",
        value: 7.12,
    },
    {
        subcategory: "wellbeing_balance",
        name: "oohc",
        datetime: "2024-04-16 00:00:00",
        value: 7.12,
    },
    {
        subcategory: "wellbeing_balance",
        name: "oohc",
        datetime: "2024-04-17 00:00:00",
        value: 7.12,
    },
    {
        subcategory: "wellbeing_patterns",
        name: "fc",
        datetime: "2024-04-11 00:00:00",
        value: 1,
    },
    {
        subcategory: "wellbeing_patterns",
        name: "fc",
        datetime: "2024-04-12 00:00:00",
        value: 1,
    },
    {
        subcategory: "wellbeing_patterns",
        name: "fc",
        datetime: "2024-04-13 00:00:00",
        value: 1,
    },
    {
        subcategory: "wellbeing_patterns",
        name: "fc",
        datetime: "2024-04-14 00:00:00",
        value: 1,
    },
    {
        subcategory: "wellbeing_patterns",
        name: "fc",
        datetime: "2024-04-15 00:00:00",
        value: 1,
    },
    {
        subcategory: "wellbeing_patterns",
        name: "fc",
        datetime: "2024-04-16 00:00:00",
        value: 1,
    },
    {
        subcategory: "wellbeing_patterns",
        name: "fc",
        datetime: "2024-04-17 00:00:00",
        value: 1,
    },
    {
        subcategory: "wellbeing_patterns",
        name: "frag",
        datetime: "2024-04-11 00:00:00",
        value: 8.1,
    },
    {
        subcategory: "wellbeing_patterns",
        name: "frag",
        datetime: "2024-04-12 00:00:00",
        value: 8.6,
    },
    {
        subcategory: "wellbeing_patterns",
        name: "frag",
        datetime: "2024-04-13 00:00:00",
        value: 9.066,
    },
    {
        subcategory: "wellbeing_patterns",
        name: "frag",
        datetime: "2024-04-14 00:00:00",
        value: 9.3,
    },
    {
        subcategory: "wellbeing_patterns",
        name: "frag",
        datetime: "2024-04-15 00:00:00",
        value: 8.8,
    },
    {
        subcategory: "wellbeing_patterns",
        name: "frag",
        datetime: "2024-04-16 00:00:00",
        value: 9.831,
    },
    {
        subcategory: "wellbeing_patterns",
        name: "frag",
        datetime: "2024-04-17 00:00:00",
        value: 9.892,
    },
    {
        subcategory: "wellbeing_patterns",
        name: "ufc",
        datetime: "2024-04-11 00:00:00",
        value: 1,
    },
    {
        subcategory: "wellbeing_patterns",
        name: "ufc",
        datetime: "2024-04-12 00:00:00",
        value: 1,
    },
    {
        subcategory: "wellbeing_patterns",
        name: "ufc",
        datetime: "2024-04-13 00:00:00",
        value: 1,
    },
    {
        subcategory: "wellbeing_patterns",
        name: "ufc",
        datetime: "2024-04-14 00:00:00",
        value: 1,
    },
    {
        subcategory: "wellbeing_patterns",
        name: "ufc",
        datetime: "2024-04-15 00:00:00",
        value: 1,
    },
    {
        subcategory: "wellbeing_patterns",
        name: "ufc",
        datetime: "2024-04-16 00:00:00",
        value: 1,
    },
    {
        subcategory: "wellbeing_patterns",
        name: "ufc",
        datetime: "2024-04-17 00:00:00",
        value: 1,
    },
    {
        subcategory: "wellbeing_patterns",
        name: "ups",
        datetime: "2024-04-11 00:00:00",
        value: 0,
    },
    {
        subcategory: "wellbeing_patterns",
        name: "ups",
        datetime: "2024-04-12 00:00:00",
        value: 0,
    },
    {
        subcategory: "wellbeing_patterns",
        name: "ups",
        datetime: "2024-04-13 00:00:00",
        value: 0,
    },
    {
        subcategory: "wellbeing_patterns",
        name: "ups",
        datetime: "2024-04-14 00:00:00",
        value: 0,
    },
    {
        subcategory: "wellbeing_patterns",
        name: "ups",
        datetime: "2024-04-15 00:00:00",
        value: 1.82,
    },
    {
        subcategory: "wellbeing_patterns",
        name: "ups",
        datetime: "2024-04-16 00:00:00",
        value: 2.34,
    },
    {
        subcategory: "wellbeing_patterns",
        name: "ups",
        datetime: "2024-04-17 00:00:00",
        value: 2.34,
    },
];

const getWellbeingMiniIndexes = () => {
    return {
        metrics,
        overall,
        timeseries,
    };
};

export default getWellbeingMiniIndexes;
